import { LifeBuoy } from 'lucide-react';

import type { SourcePlatform } from '~entities/import-job/api/types';

import { Button } from '~shared/shadcn/ui/button';

/** External support form (QA 2.1). */
const SUPPORT_URL = 'https://help.enrollio.ai/';

interface HelpRailProps {
  sourcePlatform: SourcePlatform;
}

export function HelpRail(_props: HelpRailProps) {
  // NOTE: Platform walkthrough videos (Loom) are hidden until real recordings
  // are available. See PLATFORM_LOOM_URLS in constants.ts. Re-enable the embed
  // here once production URLs replace the placeholders.
  return (
    <div className='sticky top-6 space-y-4 rounded-lg border bg-muted/30 p-4'>
      <div className='flex items-center gap-2'>
        <LifeBuoy className='size-4 text-muted-foreground' />
        <h2 className='text-sm font-semibold'>Need a hand?</h2>
      </div>
      <p className='text-sm text-muted-foreground'>
        Stuck on an import step? Send us the details and our team will help you
        get your data in.
      </p>
      <Button variant='outline' size='sm' className='w-full' asChild>
        <a href={SUPPORT_URL} target='_blank' rel='noopener noreferrer'>
          Contact support
        </a>
      </Button>
    </div>
  );
}
